import React from "react";
import appURLs from "../../appURL";
import getFetchConfig from "../../utils/getFetchConfig";
import Header from "../../component/header/Header";
import Footer_menu from "../../component/footer_menu";
import showalertStyle from "./Show_alerts.module.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Show_alerts({ count }) {
  const fetchConfig = getFetchConfig();
  const appURL = appURLs();
  const [getNotification, setGetNotification] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [readAll, setReadAll] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [loadingError, setLoadingError] = useState(null); // Optional error state

  const getAdsAlert = async (page = 1) => {
    setIsLoading(true); // Set loading to true before fetch
    setLoadingError(null); // Clear any previous errors
    
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const endpoint = readAll
        ? `${appURL}/posts/ads/read-notifications?read_all=true`
        : `${appURL}/posts/ads/fetch-notifications?page=${page}`;

      const response = await fetch(endpoint, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      setGetNotification(jsonData.notifications);
      setTotalPages(jsonData.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingError(error.message); // Set error message
    } finally {
      setIsLoading(false); // Set loading to false after fetch completes (success or error)
    }
  };

  useEffect(() => {
    getAdsAlert(currentPage);
  }, [count, currentPage]);

  const markAllAsRead = () => {
    setReadAll(true);
  
  };

  const markNotificationAsRead = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const endpoint = `${appURL}/posts/ads/read-notifications?read_id=${id}`;

      const response = await fetch(endpoint, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

    
    } catch (error) {
      console.error(`Error marking notification with ID ${id} as read:`, error);
    }
  };

  const markAllNotificationsAsRead = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const endpoint = `${appURL}/posts/ads/read-notifications?read_all=true`;

      const response = await fetch(endpoint, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

  
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };

  const getTimeSinceCreation = (createdAt) => {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();

    const timeDiff = currentDate - createdDate;

    const secondsDiff = timeDiff / 1000;

    if (secondsDiff < 60) {
      return "just now";
    } else if (secondsDiff < 3600) {
      const minutesDiff = Math.floor(secondsDiff / 60);
      return minutesDiff === 1 ? "1 minute ago" : `${minutesDiff} minutes ago`;
    } else if (secondsDiff < 86400) {
      const hoursDiff = Math.floor(secondsDiff / 3600);
      return hoursDiff === 1 ? "1 hour ago" : `${hoursDiff} hours ago`;
    } else if (secondsDiff < 172800) {
      return "Yesterday";
    } else {
      const daysDiff = Math.floor(secondsDiff / 86400);
      return daysDiff === 1 ? "1 day ago" : `${daysDiff} days ago`;
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // useEffect(() => {
  //   window.scrollTo(0, window.innerHeight * 0.6);
  // }, [currentPage, totalPages]);
  useEffect(() => {
  window.scrollTo(0, 0);  // scroll to top on page change
}, [currentPage]);

  // Show loader while loading
  if (isLoading) {
    return (
      <div className={showalertStyle.loader_container}>
        <div className={showalertStyle.loader}>
          <div className={showalertStyle.spinner}></div>
          <p>Loading notifications...</p>
        </div>
      </div>
    );
  }

  // Show error message if there's an error
  if (loadingError) {
    return (
      <div className={showalertStyle.error_container}>
        <div className={showalertStyle.error_icon}>
          <i className="fa-solid fa-exclamation-circle"></i>
        </div>
        <h3>Oops! Something went wrong</h3>
        <p>{loadingError}</p>
        <button 
          className={showalertStyle.retry_button}
          onClick={() => getAdsAlert(currentPage)}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <>
      {getNotification && getNotification.length > 0 ? (
        <div className={showalertStyle.main_showing}>
          {/* Header with Notifications and Read All - aligned with cards */}
          <div className={showalertStyle.header_wrapper}>
            <h1>Notifications</h1>
            <div className={showalertStyle.read_all} onClick={markAllNotificationsAsRead}>
              <button>Read All</button>
            </div>
          </div>

          {/* Notifications Container - matches width of cards */}
          <div className={showalertStyle.notifications_container}>
            {getNotification.map((notification) => (
              <Link
                style={{ color: "black" }}
                to={
                  notification?.data?.model === "Buy & Sell"
                    ? `/buySellDetails/${notification?.data?.model_id}`
                    : notification?.data?.model === "Events"
                    ? `/eventDetails/${notification?.data?.model_id}`
                    : notification?.data?.model === "Babysitters & Nannies"
                    ? `/babySitterDetails/${notification?.data?.model_id}`
                    : notification?.data?.model === "Local Biz & Services"
                    ? `/localBizDetails/${notification?.data?.model_id}`
                    : notification?.data?.model === "Rentals"
                    ? `/rentDetails/${notification?.data?.model_id}`
                    : notification?.data?.model === "Jobs"
                    ? `/jobDetails/${notification?.data?.model_id}`
                    : ""
                }
                key={notification._id}
                onClick={() => {
                  if (readAll) {
                    markAllNotificationsAsRead();
                  } else {
                    markNotificationAsRead(notification._id);
                  }
                }}
              >
                <div className={`${showalertStyle.boxDiv} ${!notification.read ? showalertStyle.unread : ''}`}>
                  <div>
                    <h5>{notification?.title || 'No Title'}</h5>
                    <p>{notification?.body || ''}</p>
                    <div className={showalertStyle.time_lapse}>
                      <p>{getTimeSinceCreation(notification?.createdAt)}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}

            {/* Show loading spinner for pagination if needed */}
            {isLoading && (
              <div className={showalertStyle.pagination_loader}>
                <div className={showalertStyle.small_spinner}></div>
                <span>Loading more...</span>
              </div>
            )}

            <div className={showalertStyle.paginations}>
              <button onClick={handlePrevPage} disabled={currentPage === 1}>
                <i className="fa-solid fa-arrow-left-long"></i>
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                <i className="fa-solid fa-arrow-right-long"></i>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={showalertStyle['empty-state']}>
          <div className={showalertStyle['empty-state-icon']}>
            <i className="fa-regular fa-bell-slash"></i>
          </div>
          <span>No notifications found!</span>
          <p>You're all caught up! Check back later for updates.</p>
        </div>
      )}
    </>
  );
}

export default Show_alerts;